import type { SVGProps } from 'react'
const SvgSyLamp = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<mask id="a" fill="#fff">
			<path
				fillRule="evenodd"
				d="M15 15.5c0-.103.056-.2.148-.246a7 7 0 1 0-6.296 0A.27.27 0 0 1 9 15.5v3a2.5 2.5 0 0 0 2.5 2.5h1a2.5 2.5 0 0 0 2.5-2.5z"
				clipRule="evenodd"
			/>
		</mask>
		<path
			fillOpacity={0.24}
			d="M9.75 8C8.79 8 8 8.79 8 9.75s.79 1.75 1.75 1.75h.75V13a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-1.5h1V13a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-1.5h.75c.96 0 1.75-.79 1.75-1.75S15.21 8 14.25 8s-1.75.79-1.75 1.75v.75h-1v-.75c0-.96-.79-1.75-1.75-1.75m0 1c.42 0 .75.33.75.75v.75h-.75c-.42 0-.75-.33-.75-.75S9.33 9 9.75 9m4.5 0c.42 0 .75.33.75.75s-.33.75-.75.75h-.75v-.75c0-.42.33-.75.75-.75"
		/>
		<path
			fillOpacity={0.24}
			d="M12 2C8.14 2 5 5.14 5 9s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7m0 1c3.32 0 6 2.68 6 6s-2.68 6-6 6-6-2.68-6-6 2.68-6 6-6"
		/>
		<path
			d="m8.852 15.254-.45.893zm6.296 0-.45-.893zM18 9a6 6 0 0 1-3.302 5.361l.9 1.786A8 8 0 0 0 20 9zm-6-6a6 6 0 0 1 6 6h2a8 8 0 0 0-8-8zM6 9a6 6 0 0 1 6-6V1a8 8 0 0 0-8 8zm3.302 5.361A6 6 0 0 1 6 9H4a8 8 0 0 0 4.402 7.147zM10 18.5v-3H8v3zm1.5 1.5a1.5 1.5 0 0 1-1.5-1.5H8a3.5 3.5 0 0 0 3.5 3.5zm1 0h-1v2h1zm1.5-1.5a1.5 1.5 0 0 1-1.5 1.5v2a3.5 3.5 0 0 0 3.5-3.5zm0-3v3h2v-3zm-5.598.647A.73.73 0 0 1 8 15.5h2c0-.457-.248-.912-.698-1.139zm6.296-1.786c-.45.227-.698.682-.698 1.139h2c0 .25-.136.513-.402.647z"
			mask="url(#a)"
		/>
	</svg>
)
export default SvgSyLamp
